export const faqs = [
  {
    q: '?האם כל אחד יכול להיות גשש',
    a: `אף אחד לא נולד כגשש אך בעזרת הדרכה נכונה, מחויבות ותרגול רב כל אחד ואחת יכולים להיות
        גששים
        `
  },
  {
    q: '?איך נראית סדנת המשפחות',
    a: `נפגשים מוקדם בבוקר, על המחצלת יהיו פרוסים עזרים רבים כגון: מגדירים, ספרים, עקבות גבס
        נבצע הכרות קצרה ושיחת מבוא על גששות. לאחר מכן נצא לשטח ויחד נראה מה הטבע יזמן לנו.
        אפשר לצפות למגוון רב מאוד של עקבות בעלי חיים שונים
        `
  },
  {
    q: '?היכן הסדנאות מתקיימות',
    a: 'על פי רוב באזור מרכז הארץ אך ניתן לקבוע בכל מקום בארץ במידה והתנאים מתאימים'
  },
  {
    q: '?מה זו סדנא בהתאמה אישית',
    a: `לאורך השנים קיבלתי גם פניות ממוקדות עם צרכים ספציפיים בתחום הגששות, לדוגמא:
        סדנא אישית, סדנא שמתמקדת בגששות מעקב, סדנא בדגש על עקבות פרוקי רגליים, סדנא
        למתקדמים ועוד...
        בסדנא זו ניתן לערוך התאמה של תכנים ואימונים שונים בהתאם לרצון הפונה, ניסיונו ורמת הידע שלו
        `
  },
  {
    q: '?איך הגעת לתחום',
    a: `מאז ומתמיד אהבתי להיות בטבע , תמיד הוקסמתי מיכולותיהם המיוחדות של גששים כפי
        שתוארו בספרים ובסרטים מסוימים. יכולות מגוונות כגון: תשומת לב לפרטים קטנים שלא כולם
        ערניים אליהם, מציאת בעלי חיים ובני אדם בעזרת העקבות ויכולת להבין על פי העקבות והסימנים
        מה התרחש באזור.
        קראתי כל מה שאפשר בתחום והתחלתי להתאמן לבד ועם חברים.
        בשלב מסוים השתתפתי בקורס גששות בדרום אפריקה ושם נחשפתי לגששות כמקצוע וכדרך חיים
        ואז החלטתי להקים את : "גששות בעקבות הטבע " על מנת להעביר את הידע הלאה
        `
  }
];
